import { render, staticRenderFns } from "./ConversationBasicFilter.vue?vue&type=template&id=0c588510&scoped=true&"
import script from "./ConversationBasicFilter.vue?vue&type=script&lang=js&"
export * from "./ConversationBasicFilter.vue?vue&type=script&lang=js&"
import style0 from "./ConversationBasicFilter.vue?vue&type=style&index=0&id=0c588510&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c588510",
  null
  
)

export default component.exports